export default "__VITE_ASSET__Co4CtVdJ__"